import {
	AttachmentDto,
	CreateMetadataCommand,
	MetadataDetailDto,
	PaginatedListOfMetadataDto,
	TopographyMetadataDto,
	UpdateMetadataCommand
} from '../models/models';
import { Metadata } from '../redux/metadata/metadata.types';
import { Attachment } from '../redux/projects/projects.types';
import { latLngInterfaceToLatLng } from './AssetService';
import { get, post, put, remove, upload } from './HttpService';
import { HttpResponse } from '../redux/http/http.types';
import { hasFailed } from '../utils';
import { dispatchSnackbar } from '../services/SnackbarService';

export async function getAllMetadata(
	queryString: string
): Promise<PaginatedListOfMetadataDto> {
	const response: HttpResponse<PaginatedListOfMetadataDto> =
		await get<PaginatedListOfMetadataDto>(
			'mapMetadata',
			`metadata${queryString}`
		);

	return response.data!;
}

export async function getMetadata(id: string): Promise<MetadataDetailDto> {
	const response: HttpResponse<MetadataDetailDto> =
		await get<MetadataDetailDto>('mapMetadata', `metadata/${id}`);

	return response.data!;
}

export async function getMetadataByPage(
	page: number,
	letter: string
): Promise<TopographyMetadataDto> {
	const response: HttpResponse<TopographyMetadataDto> =
		await get<TopographyMetadataDto>(
			'mapMetadata',
			`metadata/page?pageNumber=${page}&letter=${letter}`
		);

	return response.data!;
}

export async function postMetadata(metadata: Metadata): Promise<string> {
	var command: CreateMetadataCommand = {
		assetId: metadata.assetId,
		chapterId: metadata.chapterId,
		topicChapterId: metadata.topicChapterId,
		regionId: metadata.regionId,
		themeId: metadata.themeId,
		chapterThemeId: metadata.chapterThemeId,
		title: metadata.title,
		aliasses: metadata.aliasses.split(';'),
		pageNumber: metadata.pageNumber,
		pageSection: metadata.pageSection,
		category: metadata.category,
		isDigitalOnly: metadata.isDigitalOnly,
		date: new Date(Date.parse(metadata.dateOfMap)),
		licenceIds: metadata.licenceIds,
		attachments: metadata.attachments?.map(mapAttachmentToAttachmentDto),
		showUnderChapter: metadata.showUnderChapter,
		showUnderRegion: metadata.showUnderRegion
	};

	const response: HttpResponse<string> = await post<
		string,
		CreateMetadataCommand
	>(`mapMetadata`, `metadata`, command);

	dispatchSnackbar('metadata', 'POST', !hasFailed(response));

	return response.data!;
}

export async function putMetadata(metadata: Metadata): Promise<void> {
	var command: UpdateMetadataCommand = {
		id: metadata.id as string,
		assetId: metadata.assetId,
		chapterId: metadata.chapterId,
		topicChapterId: metadata.topicChapterId,
		regionId: metadata.regionId,
		themeId: metadata.themeId,
		chapterThemeId: metadata.chapterThemeId,
		title: metadata.title,
		aliasses: metadata.aliasses.split(';'),
		pageNumber: metadata.pageNumber,
		pageSection: metadata.pageSection,
		category: metadata.category,
		isDigitalOnly: metadata.isDigitalOnly,
		date: new Date(Date.parse(metadata.dateOfMap)),
		licenceIds: metadata.licenceIds,
		attachments: metadata.attachments?.map(mapAttachmentToAttachmentDto),
		showUnderChapter: metadata.showUnderChapter,
		showUnderRegion: metadata.showUnderRegion
	};

	const response: HttpResponse = await put<UpdateMetadataCommand>(
		'mapMetadata',
		`metadata`,
		command
	);

	dispatchSnackbar('metadata', 'PUT', !hasFailed(response));
}

export async function removeMetadata(id: string): Promise<void> {
	const response: HttpResponse = await remove(`metadata`, `metadata/${id}`);

	dispatchSnackbar('metadata', 'DELETE', !hasFailed(response));
}

export async function getMetadataCategories(): Promise<string[]> {
	const response: HttpResponse = await get<string[]>(
		'metadata',
		'metadata/categories'
	);

	return response.data!;
}

export async function uploadTopographyData(file: File): Promise<void> {
	const response: HttpResponse = await upload(`metadata/topography`, file);
	const isSuccess: boolean = !hasFailed(response);
	dispatchSnackbar(
		`metadata`,
		'POST',
		isSuccess,
		`Topografische data uploaden ${isSuccess ? 'gelukt' : 'mislukt'}.`
	);
}

function mapAttachmentToAttachmentDto(attachment: Attachment): AttachmentDto {
	return {
		id: attachment.id,
		type: attachment.type,
		title: attachment.title,
		description: attachment.description,
		location: attachment.location,
		pointOnMap: attachment.pointOnMap
			? latLngInterfaceToLatLng(attachment.pointOnMap)
			: undefined,
		order: attachment.order,
		isAuthorContent: true
	};
}
